{
  "version": 1,
  "asset_id": "2c9a2a35-48d1-46fa-aea2-1ce47e09dd1f",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/2c9a2a35-48d1-46fa-aea2-1ce47e09dd1f/applied-tan.jpeg",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/2c9a2a35-48d1-46fa-aea2-1ce47e09dd1f/applied-tan.jpeg",
  "original_filename": "applied-tan.jpeg",
  "size": 1246977,
  "content_type": "image/jpeg",
  "created_at": "2026-08-02T15:18:22Z"
}
